import { ApiRef, createApiRef } from '@backstage/core-plugin-api';

export const aiResourceApiRef: ApiRef<AiResourceApi> =
  createApiRef<AiResourceApi>({
    id: 'plugin.aiecosystem-resource.api',
  });

export interface AiResourceApi {
  /**
   * Get all onboarding resources
   */
  getOnboardingResources(): ResourceData[];
  /**
   * Get all massp4ai resources
   */
  getMassPResources(): ResourceData[];
  /**
   * Get all ai playground resources
   */
  getAiPlaygroundResources(): ResourceData[];
}

/**
 * Core data structure for AI ecosystem resources
 */
export interface ResourceData {
  id: string;
  title: string;
  icon?: string;
  subtitle?: string;
  description: string;
  buttonText?: string;
  url?: string;
  image?: string;
  featureFlag?: boolean;
  searchKeywords?: string[];
}

/**
 * Structure for resources data
 */
export interface ResourcesData {
  resources: ResourceData[];
}
